module.exports = __webpack_public_path__ + "img/list-empty.ad12a241.png";